module.exports = __webpack_public_path__ + "static/media/Программа УОМШ-24.f973325c.pdf";